/*

  Summary

    0 - Functions
    1 - Fixed Navigation
    2  - Carousel Timeline
    3 - Animations image
*/

const isMobile = window.screen.width <= 768

/*-------------/ 0 - Functions /-----------*/
function setSmoothScrollTo(endX, endY, duration) {
    const startX = window.scrollX || window.pageXOffset;
    const startY = window.scrollY || window.pageYOffset;
    const distanceX = endX - startX;
    const distanceY = endY - startY;
    const startTime = new Date().getTime();

    duration = typeof duration !== "undefined" ? duration : 400;

    const easeInOutQuart = (time, from, distance, duration) => {
        if ((time /= duration / 2) < 1)
            return (distance / 2) * time * time * time * time + from;
        return (-distance / 2) * ((time -= 2) * time * time * time - 2) + from;
    };

    const timer = setInterval(() => {
        const time = new Date().getTime() - startTime;
        const newX = easeInOutQuart(time, startX, distanceX, duration);
        const newY = easeInOutQuart(time, startY, distanceY, duration);
        if (time >= duration) {
            clearInterval(timer);
        }
        window.scroll(newX, newY);
    }, 1000 / 60);
}

function gsapAnimation(number, zIndex) {
    gsap.to('#navigation-institutional', {
        opacity: number,
        zIndex: zIndex,
        duration: 0.6,
    })
}

function removeOrAddInstitutionalNavigate(action) {
    switch (action) {
        case 'remove': {
            gsapAnimation(0, -1000)
            break
        }
        case 'add': {
            gsapAnimation(1, 99)
            break
        }
    }
}

function setHeightTimeline(data) {
    const paddingBottom = Number(getComputedStyle(timeline).paddingBottom.replace('px', ''))
    const timelineHeight = timelineSliders[data.realIndex].getBoundingClientRect().height
    const height = paddingBottom + timelineHeight + 'px'
    gsap.to(timeline, {
        height: height,
        duration: 0.4,
    })
}

function animateSVG() {
    anime({
        targets: '.svg-path-animate path',
        strokeDashoffset: [anime.setDashoffset, 0],
        easing: 'easeInOutSine',
        duration: 2000,
        delay: 0,
        loop: false
    });

    anime({
        targets: '.svg-path-animate',
        opacity: 1,
        easing: 'easeInOutSine',
        duration: 1000,
        delay: 0,
        loop: false
    });

}

/*-------------/ 1 - Fixed Navigation /-----------*/
const url = window.location.pathname
const navigationLinks = document.querySelector("#navigation-institutional")
switch (url) {
    case '/institucional/empresa': {
        navigationLinks.querySelector(".the-company").classList.add('active')
        break
    }

    case '/institucional/tecnologia': {
        navigationLinks.querySelector(".technology").classList.add('active')
        break
    }

    case '/institucional/sustentabilidade': {
        navigationLinks.querySelector(".sustainability").classList.add('active')
        break
    }
}
document.body.addEventListener('mousemove', (mouse) => {
    const windowWidth = window.screen.width
    const windowHeight = window.screen.height
    const positionX = mouse.clientX
    const positionY = mouse.pageY

    if (positionY < windowHeight * 0.75) {
        removeOrAddInstitutionalNavigate('add')
    } else {
        removeOrAddInstitutionalNavigate('remove')
    }
})


/*-------------/ 2 - Carousel Timeline /-----------*/
//Init Timeline
const timeline = document.getElementById('timeline-swiper')
const timelineSliders = document.querySelectorAll("#timeline-swiper .swiper-slide")
const timelineSwiper = new Swiper('.timeline--swiper-slider', {

    loop: false,

    autoplay: {
        delay: 5000, // Tempo em milissegundos entre cada slide (se desejar manter o autoplay com um atraso)
        disableOnInteraction: false, // Impede que o autoplay seja interrompido quando o usuário interage com o slide
    },


    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },

    breakpoints: {
        0: {
            slidesPerView: 1,
            spaceBetween: 20,
        },
        768: {
            slidesPerView: 2,
            spaceBetween: 40,
        },

        1250: {
            slidesPerView: 3,
            spaceBetween: 70,
        },
    }

});
//Timeline Config Height
isMobile ? timeline.style.height = `${timelineSliders[0].getBoundingClientRect().height + Number(getComputedStyle(timeline).paddingBottom.replace('px', ''))}px` : ''

timelineSwiper.on('slideChangeTransitionStart', function () {
    isMobile ? setHeightTimeline(this) : ''
});



/*-------------/ 3 - Animations image /-----------*/
gsap.registerPlugin(ScrollTrigger);


const SVGSToBeAnimated = document.querySelectorAll('.svg-path-animate')
SVGSToBeAnimated.forEach(svg => {
    gsap.to(svg, {
        scrollTrigger: {
            trigger: svg,
            start: "top 90%",
        },
        onComplete: () => animateSVG()
    });
})





